import React, { useEffect } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { AddonsProduct } from '../Addons/AddonsProduct/AddonsProduct';
import { ServiceAddon } from '../Addons/ServiceAddon/ServiceAddon';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import {
  getAddonsCount,
  mapAddonForEntryPopupDisplay,
} from '../Addons/addonEntryPopupHelpers';
import '../Addons/AddonsProduct/AddonsProduct.scss';
import '../Addons/ServiceAddon/ServiceAddon.scss';
import './PopUpAddon.scss';

export const PopUpAddon = ({
  addon,
  showPopUp,
  onClose,
  onAdd,
  onContinue,
  handleUpdateAddons,
  saleType,
  flowType,
  reportDWH,
  isLoadingShoppingCart,
  buildUrlAndOpenWindow,
}) => {
  const funnelName = flowType === 'newCustomer' ? '_New' : '_Exists';
  const displayAddon = mapAddonForEntryPopupDisplay(addon);
  const addons = displayAddon ? [displayAddon] : [];
  const isEquipment = displayAddon?.isEquipment;

  useEffect(() => {
    if (!addon) {
      return;
    }

    gtag4({
      event: `${saleType}_Step5_AddonEntryPopUp`,
      step: '5',
      content: addon?.cmsData?.id,
      action: 'AddonEntryPopUp',
      funnel_name: `${saleType}_Exists${funnelName}_Customer`,
    });
    reportDWH?.({ actionType: 'AddOns', status: 'Ongoing', messageText: 'Addon Entry PopUp Displayed' });
  }, [addon?.name]);

  if (!displayAddon) {
    return null;
  }

  const handleClickAdd = () => {
    const count = isEquipment
      ? Math.max(getAddonsCount(displayAddon.addonsList), 1)
      : 1;

    onAdd(count);
    gtag4({
      event: `${saleType}_Step5_AddonEntryPopUpAdd`,
      step: '5',
      content: displayAddon.cmsData?.id,
      action: 'AddonEntryPopUpAdd',
      button: 'הוסיפו לי',
      funnel_name: `${saleType}_Exists${funnelName}_Customer`,
    });
    reportDWH?.({ actionType: 'AddOns', status: 'Ongoing', messageText: 'Addon Entry PopUp Add Clicked' });
  };

  const handleClickContinue = () => {
    onContinue();
    gtag4({
      event: `${saleType}_Step5_AddonEntryPopUpSkip`,
      step: '5',
      content: displayAddon.cmsData?.id,
      action: 'AddonEntryPopUpSkip',
      button: 'נמשיך בלי',
      funnel_name: `${saleType}_Exists${funnelName}_Customer`,
    });
    reportDWH?.({ actionType: 'AddOns', status: 'Ongoing', messageText: 'Addon Entry PopUp Skip Clicked' });
  };

  return (
    <PopUp showPopUp={showPopUp} onClose={onClose} className='pop-up-addon'>
      {isEquipment ? (
        <AddonsProduct
          addons={addons}
          handleUpdateAddons={handleUpdateAddons}
          gtag4={gtag4}
          saleType={saleType}
          flowType={funnelName}
          isLoadingShoppingCart={isLoadingShoppingCart}
          buildUrlAndOpenWindow={buildUrlAndOpenWindow}
          getAddonsCount={getAddonsCount}
          isEntryPopup
        />
      ) : (
        <ServiceAddon
          serviceAddons={addons}
          gtag4={gtag4}
          saleType={saleType}
          flowType={funnelName}
          buildUrlAndOpenWindow={buildUrlAndOpenWindow}
          isEntryPopup
        />
      )}
      <div className='btn-wrapper-single-addons'>
        <BtnSubmit onclick={handleClickAdd} text='הוסיפו לי' />
        <BtnSubmit className='btn-submit-outline' onclick={handleClickContinue} text='נמשיך בלי' />
      </div>
    </PopUp>
  );
};
